export default "__VITE_ASSET__0dce4b13__"